import React, { useState, useRef } from "react";
import { Popconfirm, Tooltip, theme } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
  SendOutlined,
} from "@ant-design/icons";
import TSTable from "../../common/TSTable";
import ColorButton from "../../common/ColorButton";
import { DELETE } from "../../frameworks/HttpClient";
import { URL_SETTING } from "../../constants/urls";
import { dateTimeToHumanString } from "../../frameworks/Util";
import ShippingModal from "../../components/setting-conponents/Buyer/ShippingModal";
import ShippingModalLocation from "../../components/setting-conponents/Buyer/ShippingModalLocation";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";

export default function BuyerSettingView() {
  const [openAddSkimModal, setOpenAddSkimModal] = useState(false);
  const [openSeeLocationModal, setOpenSeeLocationModal] = useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessage(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessage(error.errorMessage);
      }
    }
  };

  const handleEdit = (record) => {
    if (!record?.id) return;
    setTarget(record);
    setOpenAddSkimModal(true);
  };

  const handleLocation = (record) => {
    if (!record?.id) return;
    setTarget(record);
    setOpenSeeLocationModal(true);
  };

  const handleDelete = async (id) => {
    if (!id) return;

    try {
      await DELETE(`${URL_SETTING.BUYER}${id}/`);
      refreshData();
    } catch (error) {}
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip triger="hover" title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                style={{ margin: 5 }}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>

            <Tooltip trigger="hover" title="ที่อยู่ส่งสินค้า">
              <ColorButton
                type="primary"
                override={colorSuccess}
                icon={<SendOutlined />}
                style={{ margin: 5 }}
                onClick={() => handleLocation(record)}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "รหัส",
      dataIndex: "code",
      key: "code",
      searcher: true,
      align: "center",
    },
    {
      title: "ชื่อลูกค้า",
      dataIndex: "name",
      key: "name",
      align: "center",
      searcher: true,
    },
    {
      title: "ที่อยู่",
      dataIndex: "address",
      key: "address",
      align: "center",
    },
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "phone",
      key: "phone",
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render: (value) => dateTimeToHumanString(value),
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessage}/>
      <ColorButton
        override={colorSuccess}
        type="primary"
        style={{ marginBottom: 10, float: "right" , marginTop : 16}}
        icon={<PlusCircleFilled />}
        onClick={() => setOpenAddSkimModal(true)}
      >
        เพิ่มลูกค้า
      </ColorButton>

      <TSTable
        columns={columns}
        size="small"
        url={`${URL_SETTING.BUYER}`}
        ref={tableRef}
      />
      <ShippingModal
        open={openAddSkimModal}
        onClose={() => {
          setOpenAddSkimModal(false);
          setTarget(null);
        }}
        target={target}
        onUpdate={() => {
          setOpenAddSkimModal(false);
          setTarget(null);
          refreshData();
        }}
      />
      <ShippingModalLocation
        open={openSeeLocationModal}
        onClose={() => {
          setOpenSeeLocationModal(false);
          setTarget(null);
        }}
        target={target}
        onUpdate={() => { 
          setOpenSeeLocationModal(false);
          setTarget(null);
          refreshData();
        }}
      />
    </div>
  );
}
